import React from "react";
import { Button, Modal } from "semantic-ui-react";
const DeleteProfileModal = ({
  openDeleteModal,
  setOpenDeleteModal,
  selectedItem,
  handleDeleteProfile,
}) => {
  return (
    <Modal
      closeIcon
      size="small"
      open={openDeleteModal}
      onClose={() => setOpenDeleteModal(false)}
    >
      <Modal.Header>Confirm Deletion</Modal.Header>
      <Modal.Content>
        Are you sure you want to delete the profile{" "}
        {selectedItem && selectedItem.ProfileName}
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={() => setOpenDeleteModal(false)}>Cancel</Button>
        <Button type="submit" negative onClick={handleDeleteProfile}>
          Delete
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export { DeleteProfileModal };
